import { Layout } from '@.layout';

export const OrdersHistory: React.FC = () => {
    return (
        <Layout name="orders" breadcrumbs={[{ name: 'Orders history', current: true }]}>
            <h1>Orders history</h1>
        </Layout>
    );
};
